/* istanbul ignore file */ // not fully implemented yet
import React, { useCallback, useContext } from 'react';
import _ from 'underscore';
import { UrlInputFluent } from '@bingads-webui-campaign-react/url-input-fluent-v2';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { IFinalUrl } from './types';
import { useStyles } from './style';

export const FinalUrl = ({
  i18n,
  finalUrl,
  setFinalUrl,
}: IFinalUrl) => {
  const classes = useStyles();
  const [localFinalUrl, setLocalFinalUrl] = React.useState(finalUrl);
  const [inputErrors, setInputErrors] = React.useState([]);

  const activity = useContext(ActivityContext) as any;
  const handleSetFinalUrl = useCallback((errors, value) => {
    setInputErrors(errors);
    setLocalFinalUrl(value);
  }, []);

  const notifyFinalURLchange = useCallback(() => {
    if (_.isEmpty(inputErrors)) {
      setFinalUrl(localFinalUrl);
      activity.signal(`[DisplayAdsEditor] ${localFinalUrl}`);
    }
  }, [inputErrors, localFinalUrl, setFinalUrl, activity]);

  const handleKeyUp = useCallback((e) => {
    const { key } = e;
    if (key === 'Enter') {
      notifyFinalURLchange();
    }
  }, [notifyFinalURLchange]);

  return (
    <UrlInputFluent
      containerClassName={classes.finalUrlInput}
      i18n={i18n}
      url={localFinalUrl}
      onChange={handleSetFinalUrl}
      additionalProperties={{ onBlur: notifyFinalURLchange, onKeyUp: handleKeyUp }}
    />
  );
};
